import React from 'react';
import {
    RouteComponentProps,
    withRouter as withReactRouter,
} from 'react-router-dom';
import { type WithRouterProps } from '../types';

export function withRouter<T extends WithRouterProps = WithRouterProps>(
    Component: React.ComponentType<T>,
) {
    const Wrapper = (
        props: Omit<T & RouteComponentProps, keyof WithRouterProps>,
    ) => {
        const { history, location } = props;

        // Convert react-router props to nearly mimic the shape of next/router
        // https://nextjs.org/docs/pages/api-reference/functions/use-router
        const pathname = location.pathname;
        const query = new URLSearchParams(location.search);
        const asPath = pathname + query;
        const isFallback = false;
        const basePath = '/d';
        const push = history.push;

        return (
            <Component
                {...(props as T)}
                router={{
                    pathname,
                    query,
                    asPath,
                    isFallback,
                    basePath,
                    push,
                }}
            />
        );
    };

    return withReactRouter(Wrapper);
}
